export default __webpack_public_path__ + "static/media/template-preview-no-image.c05292d1.png";